import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mt-2" }
const _hoisted_2 = { class: "d-flex justify-content-end m-3 mt-4" }

import { ref, watch} from "vue"
import i18n from '@/lang/i18n';

type Props = {
  title: string
  dialogState: boolean
  actionKey: string
  confirmText: string
  modalMaxWidth?: string
  execBtnName?: string
  btnClass?: string
  closeBtnName?: string
  closeBtnClass?: string
  isLoading: boolean
  message?: string
  disabled?: boolean
  resultMessageColor: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    title: {},
    dialogState: { type: Boolean, default: false },
    actionKey: {},
    confirmText: {},
    modalMaxWidth: { default: '50%' },
    execBtnName: { default: i18n.global.t('pages.common.button.exec') },
    btnClass: {},
    closeBtnName: { default: i18n.global.t('pages.common.button.close') },
    closeBtnClass: {},
    isLoading: { type: Boolean },
    message: {},
    disabled: { type: Boolean },
    resultMessageColor: {}
  },
  emits: ['closeModal', 'exec'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const state = ref<boolean>(false)

function close() {
  state.value = false
  emits("closeModal", props.disabled)
}

watch(() => props.dialogState, (value: boolean) => {
    state.value = value
    if (state.value) return
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: state.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state).value = $event)),
    width: "25%",
    "max-width": __props.modalMaxWidth,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { style: {"background-color":"white"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "modal-header d-flex justify-content-center mt-2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "modal-body p-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(props.confirmText), 1),
              _createElementVNode("div", {
                class: "text-center mt-2",
                style: _normalizeStyle({color: props.resultMessageColor})
              }, _toDisplayString(props.message), 5),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  class: _normalizeClass(["close-btn", __props.closeBtnClass]),
                  disabled: props.isLoading,
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.closeBtnName), 1)
                  ]),
                  _: 1
                }, 8, ["class", "disabled"]),
                _createVNode(_component_v_btn, {
                  class: _normalizeClass(["exec-btn ml-2", props.btnClass]),
                  style: _normalizeStyle({ backgroundColor: props.disabled ? 'rgb(179, 184, 187)' : '', }),
                  disabled: props.disabled,
                  loading: props.isLoading,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('exec')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.execBtnName), 1)
                  ]),
                  _: 1
                }, 8, ["class", "style", "disabled", "loading"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "max-width"]))
}
}

})